<template>
  <b-container class="main-container">
    <h3 v-if="collaborator">
      {{collaborator.firstName}} {{collaborator.lastName}} 
      <span v-if="userInfo">( <a target="_blank" :href="'https://isearch.asu.edu/profile/' + userInfo.eid">iSearch</a> )</span>
    </h3>
    <a :href="'mailto:' + collaborator.email"><font-awesome-icon icon="envelope" class="mr-2"/>{{collaborator.email}}</a>
    <div v-if="userInfo">
      <div>{{userInfo.title}}</div>
      <div>{{userInfo.department }}</div>
      <div>{{campus}}</div>
      <div>{{ employeeType }}</div>
      <div>FTE: {{ primaryEmployeeJob ? primaryEmployeeJob.fte: "" }}</div>
      
    </div>
    <b-row>
      <b-col sm="12">

        <div class="mt-2 mb-2">
          <tags :tags="tags" :can-edit="isOwner" :app="appName" :object="objectName" :object-id="asuriteId" @success="loadTags()"/>
        </div>

        <widget heading="Translational Teams" icon="users">
          <translational-teams :items="translationalTeams"></translational-teams>
        </widget>

        <widget heading="Sponsored Awards" icon="file-invoice-dollar">
          <awards :awards="collaborator.awards" :manageAwards="false"></awards>
        </widget>

        <widget heading="Proposals" icon="file-invoice-dollar">
          <proposals :proposals="collaborator.proposals" :manageProposals="false"></proposals>
        </widget>
        
        <!-- <widget heading="Research Collaborators">
          <research-collaborators :collaborators="collaborators"></research-collaborators>
        </widget> -->

        <widget heading="Other Projects" icon="pencil-alt">
          <projects :items="projects"></projects>
        </widget>

        <widget heading="Community Partnerships" icon="hands-helping">
          <community-partners :items="collaborator.communityPartners"></community-partners>
        </widget>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/researchCollaborators";
import employeeApi from "../../api/employees";
import projectApi from "../../api/projects";
import usersApi from "../../api/auth";
import tagsApi from "../../api/objectTags";
import Widget from "../../components/widget";
import Awards from "../../components/experts/awards";
import Proposals from "../../components/experts/proposals";
import CommunityPartners from "../../components/experts/community-partners";
import TranslationalTeams from "../../components/experts/translationalTeams";
import Projects from "../../components/experts/projects";
import Tags from "../../components/tags";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],

  data() {
    return {
      collaborator: {
        expertise: [],
        awards: [],
        proposals: [],
        communityPartners: []
      },
      userInfo: null,
      tags: [],
      projects: [],
      translationalTeams: [],
      appName: process.env.VUE_APP_NAME,
      objectName: "Employees"
    };
  },

  props: {
    asuriteId: {
      required: true
    }
  },

  components: {
    widget: Widget,
    awards: Awards,
    "community-partners": CommunityPartners,
    TranslationalTeams,
    Projects,
    Tags,
    Proposals
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    // communityPartners: function() {
    //   var partner_list = [];

    //   this.collaborator.awards.forEach(function(award) {
    //     award.communityPartners.forEach(function(partner) {
    //       partner_list.push(partner);
    //     });
    //   });

    //   return _.uniqBy(partner_list, function(partner) {
    //     return partner.id;
    //   });
    // },
    isOwner: function() {
      if (this.isExpertsAdmin) {
        return true;
      }
      return false;
    },
    campus: function() {
      var campusSplit = this.userInfo.campusAffiliation.match(/[A-Z][a-z]+/g);
      var campus = "";
      _.forEach(campusSplit, word => {
        campus += word += " ";
      });
      return campus;
    },
    employeeType: function() {
      if (this.primaryEmployeeJob) {
        if (this.primaryEmployeeJob.paygroup === "SAL") {
          return "Fiscal Year";
        }
        if (
          this.primaryEmployeeJob.paygroup === "ACD" ||
          this.primaryEmployeeJob.paygroup === "A12"
        ) {
          return "Academic Year";
        }
      }
      return "";
    },
    primaryEmployeeJob: function() {
      if (!this.employeeJobs.length) {
        return null;
      }
      var primary = _.find(this.employeeJobs, function(employeeJob) {
        return employeeJob.jobIndicator === "P";
      });
      if (primary) {
        return primary;
      }
      return this.employeeJobs[0];
    },
  },

  methods: {
    loadTags() {
      var that = this;
      tagsApi
        .getObjectTags(this.appName, this.objectName, this.asuriteId)
        .then(response => {
          that.tags = response.data;
        });
    },
    loadProjects() {
      projectApi.getProjectsByAsurite(this.asuriteId).then(response => {
        this.projects = response.data;
      });
    },
    loadTranslationalTeams() {
      employeeApi.getTranslationalTeams(this.asuriteId).then(response => {
        this.translationalTeams = response.data;
      });
    },
    loadJobs() {
      employeeApi.getEmployeeJobs(this.asuriteId).then(response => {
        this.employeeJobs = response.data;
      });
    }
  },

  created() {
    var that = this;

    api
      .getResearchCollaboratorById(this.asuriteId)
      .then(function(response) {
        that.collaborator = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    usersApi
      .findLDAP(this.asuriteId)
      .then(response => {
        if (response.data.length) {
          that.userInfo = _.find(response.data, item => {
            return (item.asuriteId = that.asuriteId);
          });
        }
      })
      .catch(error => {
        console.log(error);
      });

    this.loadTags();
    this.loadProjects();
    this.loadTranslationalTeams();
    this.loadJobs();
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}
</style>
